import {COLUMN_DISPLAY_NAME, COLUMN_NAME, COLUMN_PERMISSIONS, COLUMN_SITE, COLUMN_UNIQUE_IDENTIFIER, COLUMN_USER_TYPE} from "../../constants/column-types";
import {FILTER_SITES, FILTER_USER_TYPE} from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const UserLoginColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "ulUsername",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 1,
        sortByName: "master.mstDisplayname",
        sortDirection: "asc",
        active: true,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
    },
    {
        heading: "Unique Identifier",
        accessor: "idNumber",
        isNumeric: true,
        id: 2,
        sortByName: "master.mstIdnumber",
        sortDirection: "asc",
        active: true,
        translationKey: "uniqueIdentifier",
        columnId: COLUMN_UNIQUE_IDENTIFIER,
    },
    {
        heading: "Permissions",
        accessor: "profile",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "permissions",
        columnId: COLUMN_PERMISSIONS,
    },
    {
        heading: "Security Policy",
        accessor: "securityPolicy",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "securityPolicy",
        // columnId: COLUMN_PERMISSIONS,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 5,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site',
        columnId: COLUMN_SITE,
    },
    {
        heading: "loginType",
        accessor: "userLoginTypeName",
        isNumeric: false,
        id: 6,
        sortByName: "userLoginTypeName",
        sortDirection: "asc",
        active: true,
        searchOnName: "userLoginTypeId",
        lookupName: "userLoginTypeName",
        translationKey: "loginType",
        filterId: FILTER_USER_TYPE,
        columnId: COLUMN_USER_TYPE,
    }
];

export default UserLoginColumns;
